export const LOGIN_END_POINT_PREFIX = "";
export const GET_ACCESS_TOKEN_END_POINT_PREFIX = "";
